<int-nav class="nav-wrapper__nav"></int-nav>

<int-nav *ngIf="isMobileNavOpen" [@navToggle] [hasBack]="true" class="nav-wrapper__nav--mobile"></int-nav>
